import React from 'react'
import { Box } from '@mui/material'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { destinationTreeAtom } from './atoms'
import { SourceTree } from './SourceTree'
import { InfoDisplay } from '../../utility/Containers'
import { SourceTreeInput } from './SourceTreeInput'
import { useGetTreeById } from '../../../reducers/trees_hooks'
import { MissingMapping } from './MissingMapping'
import { MappedNodes } from './MappedNodes'
import { DestinationTree } from './DestinationTree'
import { ReplaceJobsStatus } from './ReplaceJobsStatus'

export function NodeReplace(ids: { treeId: string; versionId: string }) {
  const tree = useGetTreeById(ids)
  useSetAtom(destinationTreeAtom)(tree)

  return (
    <Box>
      <Box>Node Replace</Box>
      <InfoNode />
      <SourceTreeInput />
      <ReplaceJobsStatus />
      <Box padding="5px">
        <MappedNodes />
      </Box>
      <Box padding="5px">
        <MissingMapping />
      </Box>
      <Box padding="5px">
        <DestinationTree />
      </Box>
      <Box padding="5px">
        <SourceTree />
      </Box>
    </Box>
  )
}

function InfoNode() {
  return (
    <InfoDisplay>
      This tool can bulk-change activity nodes in this curriculum to match what
      exists in another curriculum. Your currently selected curriculum will be
      changed. Select a second curriculum below to copy from (this second
      curriculum will not be changed).{' '}
      <Box>
        This tool will match any activities that exist in both curricula by
        looking for an exact title match.
      </Box>
      <Box>
        Then, the tool will produce a list of all the nodes that will be
        updated.
      </Box>
      <Box>
        Next, the tool will allow you to un-select nodes that should not be
        changed.
      </Box>
      <Box>
        Finally, the tool will allow you to bulk-change the selected nodes.
      </Box>
    </InfoDisplay>
  )
}
